// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"52a11225","909":"5a345ad1"}[chunkId] + ".chunk.css";
};